export default "__VITE_ASSET__Bu7RL3Ay__"